import styled from 'styled-components';

import { Color, FontWeight, Media } from '../../../../theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CounterRow = styled.div`
  padding: 35px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid ${Color.veryLightGrey};
  & + & {
    border-top: 0;
  }
`;

export const IconWithValuesContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const CounterIcon = styled.img``;

export const ValueDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 35px;
`;

export const Value = styled.div`
  color: ${Color.darkGrey};
  font-size: 25px;
  font-weight: 300;
  letter-spacing: 0.14px;
  line-height: 33px;
`;

export const Description = styled.div`
  color: ${Color.darkSilver};
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 26px;
`;

export const TwoCircles = styled.div`
  width: 105px;
  height: 70px;
  position: relative;
  margin-left: 20px;
  ${Media.desktop`
    display: none;
  `}
`;

export const Circumference = styled.div`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border: 1px solid ${Color.veryLightGrey};
  position: absolute;
  top: 0;
  right: 0;
`;

export const Circle = styled(Circumference)`
  background-color: ${Color.white};
  border-color: ${Color.transparent};
  left: 0;
  right: auto;
`;
